import {
  OPEN_ITEM_DETAIL,
  CLOSE_ITEM_DETAIL,
} from '../actions'

const itemDetail = (state = null, action) => {
  switch (action.type) {
    case OPEN_ITEM_DETAIL:
      return action.item
    case CLOSE_ITEM_DETAIL:
      return null
    default:
      return state;
  }
};

export default itemDetail;



// WEBPACK FOOTER //
// ./src/reducers/itemDetail.js